// @ts-nocheck
import React from 'react';
import {usePackagesByUnit} from '../../../hooks/packages';
import LoadingSpinner from '../../../components/LoadingSpinner';
import {FlatList, Platform, StyleSheet, TouchableOpacity, View} from 'react-native';
import Text from '../../../components/Text';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import PackagesItem from '../components/PackageItem';
import {useDispatch, useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import {setDeliveriesTabSelected} from '../deliveriesReducer';
import {Package} from '../types';
import isWeb from '../../../utils/isWeb';

const FILTER_OPTIONS: Array<'Unclaimed' | 'Claimed' | 'All'> = [
  'Unclaimed',
  'Claimed',
  'All',
];

export default function Packages() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const currentUnitId = useSelector((state: RootStore) =>
    state.units.unitLinks?.find(link => link.isDefault === true)?.unit?.id,
  );
  const [status, setStatus] = React.useState<'Unclaimed' | 'Claimed' | 'All'>(
    'Unclaimed',
  );
  const {isLoading, data, refetch, isRefetching} = usePackagesByUnit(
    currentUnitId,
    status === 'All' || status === 'Claimed',
    status === 'Claimed',
  );
  const packages: Array<Package> = data?.data;

  const enabledRef = React.useRef(false);

  useFocusEffect(
    React.useCallback(() => {
      if (enabledRef.current) {
        refetch();
      } else {
        enabledRef.current = true;
      }
    }, [refetch]),
  );

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      dispatch(setDeliveriesTabSelected(false));
    });

    return unsubscribe;
  }, [dispatch, navigation]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <View style={styles.container}>
      {/* Filter Chips Bar */}
      <View style={styles.filterRow}>
        {FILTER_OPTIONS.map(opt => {
          const isActive = status === opt;
          return (
            <TouchableOpacity
              key={opt}
              style={[styles.filterChip, isActive && styles.activeFilterChip]}
              onPress={() => setStatus(opt)}>
              <Text style={[styles.filterText, isActive && styles.activeFilterText]}>
                {opt}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>

      <FlatList
        style={styles.list}
        data={packages}
        ListEmptyComponent={
          <View style={styles.emptyContainer}>
            <Text style={styles.emptyText}>No packages found</Text>
          </View>
        }
        renderItem={({item}) => (
          <PackagesItem
            packageItem={item}
            itemClickHandler={() =>
              navigation.navigate(E_NAVIGATION_DESTINATIONS.PACKAGE_DETAILS, {
                packageItem: item,
              })
            }
          />
        )}
        onRefresh={refetch}
        refreshing={isRefetching}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  filterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    gap: 8,
  },
  filterChip: {
    paddingHorizontal: 14,
    paddingVertical: 6,
    borderRadius: 999,
    backgroundColor: '#f4f4f5',
    borderWidth: 1,
    borderColor: '#e4e4e7',
  },
  activeFilterChip: {
    backgroundColor: '#6366f1',
    borderColor: '#6366f1',
  },
  filterText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#71717a',
  },
  activeFilterText: {
    color: '#ffffff',
  },
  list: {
    marginBottom: Platform.OS === 'ios' ? 160 : isWeb ? 0 : 100,
    paddingHorizontal: 4,
  },
  emptyContainer: {
    padding: 24,
    alignItems: 'center',
  },
  emptyText: {
    color: '#71717a',
    fontSize: 14,
  },
});
